export const ReadRight = "WEB_MODULE_QUAY_MANUAL_READ";

export const Rights = [
    ReadRight
]
